import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get purchaseCreditNote
export const getPurchaseCreditNote = createAsyncThunk(
  "purchaseCreditNote/getPurchaseCreditNote",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getPurchaseCreditNote({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all purchaseCreditNote
export const getAllPurchaseCreditNote = createAsyncThunk(
  "purchaseCreditNote/getAllPurchaseCreditNote",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllPurchaseCreditNote();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("purchaseCreditNote/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("purchaseCreditNote/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "purchaseCreditNote/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePurchaseCreditNote({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getPurchaseCreditNoteById = createAsyncThunk(
  "purchaseCreditNote/getPurchaseCreditNoteById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseCreditNoteById(id);

      if (data?.data.drCrNotesDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.drCrNotesDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id);

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, drCrNotesDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create purchaseCreditNote
export const createPurchaseCreditNote = createAsyncThunk(
  "purchaseCreditNote/createPurchaseCreditNote",
  async (createData, { rejectWithValue }) => {
    const {
      purchaseInvoiceMain,
      drCrNotesDetails,
      drCrNotesPartyDetails,

      // invoiceNo,
      // refNo,
      voucherDateBs,
      voucherDate,
      narration,
      branch,

      deliveryDocNo,
      termsOfPayment,
      partyAccount,
      otherReferences,
      termsOfDelivery,
      destination,
      deliveryThrough,
      deliveryDocNumber,
      find,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        purchaseInvoiceMain,
        drCrNotesDetails,

        drCrNotesPartyDetails,

        noteType: "purchase_credit",
        // invoiceNo,
        // refNo,
        voucherDateBs,
        voucherDate,

        branch,
        termsOfPayment,
        deliveryDocNo,

        narration,

        partyAccount,
        otherReferences,
        termsOfDelivery,
        destination,
        deliveryThrough,
        deliveryDocNumber,
        find,
        grandTotal,
        vatAmount,
      });

      const { data } = await API.createPurchaseCreditNote(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updatePurchaseCreditNote = createAsyncThunk(
  "purchaseCreditNote/updatePurchaseCreditNote",
  async (params, { rejectWithValue }) => {
    const { id, submitData } = params;
    const {
      salesOrder,
      indentNo,
      voucherDateBs,
      voucherDate,
      branch,
      termsOfPayment,
      drCrNotesPartyDetails,

      // yo field name mileko thiyena, fix bhayo hai
      documentsAttach,
      // refVoucher,
      drCrNotesDetails,
    } = submitData;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        branch,
        termsOfPayment,
        status: "approved",
        drCrNotesPartyDetails,

        voucherDateBs,
        voucherDate,
        // refVoucher,
        drCrNotesDetails,
      });
      const { data } = await API.updatePurchaseCreditNote(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getPurchaseCreditNoteDetailsById = createAsyncThunk(
  "purchaseCreditNote/getPurchaseCreditNoteDetailsById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseCreditNoteDetailsById(id);

      if (data?.data.purchaseInvoiceDetail?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.purchaseInvoiceDetail.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, purchaseInvoiceDetail: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "purchaseCreditNote/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
